import { PageRecipientBasicModel } from '@/helpers/entities/models/PageRecipientBasicModel';
import { omit } from 'lodash';
import moment from 'moment';
import { NotificationableType } from '../enums/v2/NotificationableType';
export class NotificationModel {
    constructor(payload) {
        Object.assign(this, omit(payload, 'pageRecipient'));
        const { pageRecipient } = payload;
        if (pageRecipient) {
            this.pageRecipient = new PageRecipientBasicModel(pageRecipient);
        }
    }
    // return formatted timestamp(1 min ago, 1 hr ago ...)
    // @see https://momentjs.com/docs/#/displaying/from/
    get createdAtSince() {
        return moment(this.createdAt).fromNow();
    }
    /**
     * Alias to Notification Order transaction number
     * @author Peter John Alvarado <peterjohn@gorated.ph>
     * @since Version 0.1.10
     *
     * @return { string }
     */
    get transactionNumber() {
        const transactionNumber = '';
        /**
         * Add Notificationable Type Validator
         * @author Peter John Alvarado <peterjohn@gorated.ph>
         * @version {0.6.0}
         */
        if (this.notifForOrder) {
            const order = this.notificationable;
            return order.transactionNumber;
        }
        return transactionNumber;
    }
    /**
     * Notificationable Type Validation For Order
     * @author Peter John Alvarado <peterjohn@gorated.ph>
     * @since Version {0.6.0}
     */
    get notifForOrder() {
        return this.notificationableType === NotificationableType.Order;
    }
    /**
     * Notificationable Type Validation For Billing
     * @author Peter John Alvarado <peterjohn@gorated.ph>
     * @since Version {0.6.0}
     */
    get notifForBilling() {
        return this.notificationableType === NotificationableType.Billing;
    }
    /*
     * Alias to Notification Billing uuid
     * @author Peter John Alvarado <peterjohn@gorated.ph>
     * @since Version 0.6.0
     *
     * @return { string }
     */
    get billingUuid() {
        const uuid = '';
        /**
         * Add Notificationable Type Validator
         * @author Peter John Alvarado <peterjohn@gorated.ph>
         * @version {0.6.0}
         */
        if (this.notifForBilling) {
            const billing = this.notificationable;
            return billing.uuid;
        }
        return uuid;
    }
    /**
     * Notificationable Type Validation For Billing
     * @author Peter John Alvarado <peterjohn@gorated.ph>
     * @since Version {0.6.0}
     */
    get notifForExtension() {
        return this.notificationableType === NotificationableType.Extension;
    }
}
